import { useMutation, FetchResult } from "@apollo/client";

import { useAuth, TypesAuth } from "../../../Store";

import { SET_AUTHENTICATION } from "./start.mutations";

interface UseSetTokenActions {
  setToken: (args?: any) => Promise<FetchResult>;
  data: any;
  error: any;
  loading: boolean;
}

interface UseSetHubTokenProps {
  setHubToken(): Promise<boolean>;
  setHubTokenLoading: boolean;
  setHubTokenError: any;
}

function useSetTokenActions(): UseSetTokenActions {
  const [setToken, { data, error, loading }] = useMutation(SET_AUTHENTICATION);
  return { setToken, loading, data, error };
}

export function useSetHubToken(): UseSetHubTokenProps {
  const [, authDispatch] = useAuth();
  const { setToken, loading, error } = useSetTokenActions();

  const setHubToken = async (): Promise<boolean> => {
    try {
      const config = { variables: { type: "hub" } };
      const response = await setToken(config);

      const { access_token, expires_in } = response?.data?.SetAuthentication;

      authDispatch({
        type: TypesAuth.setHubToken,
        payload: {
          accessToken: access_token,
          expiresIn: expires_in,
        },
      });

      return true;
    } catch (err: any) {
      console.log({ ...err });
      return false;
    }
  };

  return {
    setHubToken,
    setHubTokenLoading: loading,
    setHubTokenError: error,
  };
}
